module.exports = "<span ng-message=pattern>*Must be a valid phone number</span> ";